import { render, staticRenderFns } from "./AddAdminDialog.vue?vue&type=template&id=3574586f&scoped=true&"
import script from "./AddAdminDialog.vue?vue&type=script&lang=js&"
export * from "./AddAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddAdminDialog.vue?vue&type=style&index=0&id=3574586f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574586f",
  null
  
)

export default component.exports